import { InvoiceItem } from "@/types";

export const feesFilter = (item: InvoiceItem) => Number(item.unit_price) > 0;
export const salesFilter = (item: InvoiceItem) => Number(item.unit_price) < 0;

/**
 * Adds `unit_price_value`, the unit price as a number, for a DataTable column to sort on: PrimeVue
 * sorts the exact decimal string by numeric collation, which puts negatives in reverse order. As a
 * float the order is exact except for ties finer than 1e-7 above 2^29.
 */
export const withUnitPriceValue = <T extends { unit_price: string }>(
  item: T
): T & { unit_price_value: number } => ({
  ...item,
  unit_price_value: Number(item.unit_price),
});

/** Ledger units per euro: the API serves exact amounts at the ledger's asset scale, 10⁻⁷ EUR. */
const UNITS_PER_EURO = 10_000_000;

/**
 * Converts an exact amount in ledger units, as the API serves it, to euros. Sum units first and
 * convert once: integer sums stay exact far beyond any balance Soldera carries (2⁵³ units is
 * ≈ 900 million EUR), and display rounds the result once.
 */
export const fromUnits = (units: number): number => units / UNITS_PER_EURO;
